import { Link, UIHeading5 } from '@cian/ui-kit';

import * as styles from './Vacancies.css';

interface IVacanciesProps {
  totalCount: string;
  totalCountText: string;
  vacancyLink: string;
  vacancy: React.ReactNode;
  onVacancyClick(): void;
}

export const Vacancies = ({ totalCount, totalCountText, vacancyLink, vacancy, onVacancyClick }: IVacanciesProps) => {
  if (!totalCount) {
    return null;
  }

  return (
    <div className={styles['container']} data-name="Vacancies">
      <UIHeading5>Вакансии</UIHeading5>
      <div className={styles['vacancy-container']}>
        {vacancy}
        <Link fontSize="S" href={vacancyLink} onClick={onVacancyClick} target="_blank">
          {totalCountText}
        </Link>
      </div>
    </div>
  );
};
